import { render, staticRenderFns } from "./AubeCoinAutomaticRemittanceConfirm.vue?vue&type=template&id=2add77c8&scoped=true&"
import script from "./AubeCoinAutomaticRemittanceConfirm.vue?vue&type=script&lang=js&"
export * from "./AubeCoinAutomaticRemittanceConfirm.vue?vue&type=script&lang=js&"
import style0 from "./AubeCoinAutomaticRemittanceConfirm.vue?vue&type=style&index=0&id=2add77c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2add77c8",
  null
  
)

export default component.exports